import React, { useState } from 'react'
import { StatusCellComponent } from '../../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';
import NoRowOverlay from '../../../../masters/holidayMaster/NoRowOverlay';
import { gridComponents, gridStyles } from '../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import { AGridColDef } from '../../../../common/data-grid/ADataGridColDef';
import ADataGrid from '../../../../common/data-grid/ADataGrid';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { GridRowModes } from '@mui/x-data-grid';
import { ActionsCellComponent } from '../../../../masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getFormattedDate } from 'views/pages/manage/edpOps/constant/batch-search';
import moment from 'moment';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import { Tooltip } from '@mui/material';

const updatedSrNo = srNo => `${srNo}`?.length === 1 ? `0${srNo}` : srNo;

const FeaturesList = ({
    featuresData,
    statusChangeHandler = () => { },
    loading,
    form: rowForm,
    setForm: setRowForm,
    currentPage,
    totalRecords,
    pageChangeHandler,
    saveHandler,
    action
}) => {

    const [rowModesModel, setRowModesModel] = useState({});
    // const [rowData, setRowData] = useState(rows);
    // const [rowForm, setRowForm] = useState({});


    // const rowFormHandler = (value, key) =>
    //     setRowForm((prev) => ({ ...prev, [key]: value }));

    // useEffect(() => {
    //     setRowData(rows);
    // }, [rows]);


    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit, fieldToFocus: "status" },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm('');
    };

    const handleEditClick = (params) => {
        if (!!rowForm) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };

    const handleCancelClick = async (params) => {
        stopEditing(params?.id);

    };

    const handleSaveClick = async (params) => {
        await saveHandler()
        stopEditing()
    };
    const columns = [

        new AGridColDef('srNo', 'Sr No.', false)
            .setMinWidth(110)
            .setFlex(0.2)
            .editable(false)
            .setValueGetter(params => updatedSrNo(params?.value)),

        new AGridColDef('feature', 'Feature', false)
            .setMinWidth(80)
            .setFlex(0.7)
            .editable(false)
            .setValueGetter(params => params?.value),

        new AGridColDef('status', 'Status', false)
            .setMinWidth(110)
            .setFlex(0.2)
            .editable(true)
            .renderCellComponent(params => (
                <StatusCellComponent value={params.value} />
            ))
            .renderEditCellComponent(params => (
                <StatusCellComponent
                    value={params?.row?.id === rowForm?.featureId ? rowForm?.status : params.value}
                    handleChange={(newStatus) => statusChangeHandler(params?.row?.id, newStatus)}
                    showText
                />
            ))
        ,
 new AGridColDef('updatedOn', 'Last Updated On', false)
            .setMinWidth(120)
            .setFlex(1.1)
            .editable(false)
            .renderCellComponent((params) =>
                params?.value ? (
                    <Tooltip title={`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}>
                        <div className="ellipsis-text-container">
                            {`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}
                        </div>
                    </Tooltip>
                ) : (
                    <div className="m-auto">-</div>
                )
            )
        ,
        ...(action != 'view' ? [new AGridColDef('action', 'Action', false)
            .setMinWidth(110)
            .setFlex(0.6)
            .editable(true)
            .columnAlign('right')
            .renderCellComponent(params =>
                <ActionsCellComponent
                    mode={'view'}
                    handleEditClick={handleEditClick}
                    params={params}
                    icon={true}
                    customEditIcon
                />
            )
            .renderEditCellComponent(params => (
                <ActionsCellComponent
                    mode={'edit'}
                    handleSaveClick={handleSaveClick}
                    handleCancelClick={handleCancelClick}
                    icon={true}
                    cancelIcon={<CancelIcon
                        className="mx-2 cursor"
                        onClick={() => handleCancelClick(params)}
                    />}
                    params={params}
                />
            ))] : []),

    ]
    return (

        <ADataGrid
            removeWrapperContainer
            rowModesModel={rowModesModel}
            rows={featuresData || []}
            columns={columns}
            rowId={(row) => row.id}
            rowHeight={50}
            loading={false}
            pageSize={10}
            rowCount={totalRecords}
            nextButtonHandler={pageChangeHandler}
            currentPage={currentPage}
            components={{
                ...gridComponents,
                NoRowsOverlay: () => (
                    <NoRowOverlay message={loading ? "Loading..." : null} />
                ),
            }}
            sx={gridStyles}
            autoHeight
        // pinLastColumn
        />

    );
}

export default FeaturesList;